import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const STORAGE_KEY = "dimedial-cookie-info-seen";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);
  const { pathname, search } = useLocation();
  // Im eingeloggten Kunden-/Adminbereich nicht anzeigen: das Login-Cookie ist technisch notwendig (kein Consent nötig) –
  // und der Hinweis lag dort über „Abmelden“ in der Sidebar, sodass der Klick ins Leere ging.
  const inApp = ["/portal", "/admin", "/baukasten", "/kunden/connect", "/player", "/einlass", "/stele/", "/app", "/studio-editor", "/pass-scanner", "/pass", "/link-in-bio", "/@", "/robbies-kaffeekueche"].some((p) => pathname.startsWith(p)) || ((pathname.startsWith("/t/") || pathname.startsWith("/v/")) && new URLSearchParams(search).get("embed") === "1");

  useEffect(() => {
    let timer;
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        timer = setTimeout(() => setVisible(true), 1800);
      }
    } catch {
      setVisible(true);
    }
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {}
    window.dispatchEvent(new Event("cookie-hint-dismissed"));
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && !inApp && (
        <motion.div
          data-testid="cookie-notice"
          role="status"
          className="fixed bottom-[calc(0.5rem_+_env(safe-area-inset-bottom))] left-2 right-2 sm:bottom-3 sm:left-3 sm:right-auto sm:max-w-[560px] z-[150] bg-ink-2/90 backdrop-blur-xl border hairline px-3 py-1.5 sm:px-3.5 sm:py-2 flex items-center gap-3 rounded-full"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-[11px] text-grey leading-snug min-w-0">
            <span className="hidden sm:inline">Kein Tracking, keine Marketing-Cookies – nur ein technisch notwendiges Login-Cookie im Kundenbereich. Details in der{" "}</span>
            <span className="sm:hidden">Kein Tracking, keine Marketing-Cookies · </span>
            <Link to="/datenschutz" data-testid="cookie-notice-link" className="text-paper underline decoration-gold/60 underline-offset-4 hover:text-gold transition-colors duration-500">
              <span className="hidden sm:inline">Datenschutzerklärung</span><span className="sm:hidden">Datenschutz</span>
            </Link><span className="hidden sm:inline">.</span>
          </p>
          <button
            type="button"
            onClick={dismiss}
            data-testid="cookie-notice-accept"
            className="shrink-0 rounded-full border border-paper/40 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-paper hover:text-gold hover:border-gold transition-colors duration-500"
          >
            Verstanden
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieNotice;
